import { createModule } from "saga-slice";
import { call, put } from "redux-saga/effects";
import refundService from "../services/refundService";
const initialState = {
    refunds: [],
    loading: false,
    error: null,
    totalElements: 0, // Total number of records
    totalPages: 0, // Total number of pages
    pageNumber: 0, // Current page number
    pageSize: 10, // Size of each page
};

const refundSlice = createModule({
    name: 'refunds',
    initialState,
    reducers: {
        addRefund: (state) => {
            state.loading = true;
        },
        search: (state) => {
            state.loading = true;
        },
        updateRefund: (state) => {
            state.loading = true;
        },
        deleteRefund: (state, action) => {
            state.loading = true;
        },
        fetchedData: (state, payload) => {
            console.log(payload);
            state.loading = false;
            state.refunds = payload.content;
            state.totalElements = payload.totalElements; // Assuming totalElements is in payload
            state.totalPages = payload.totalPages; // Assuming totalPages is in payload
            state.pageNumber = payload.pageNumber;
        },
        finishFetching: (state) => {
            state.loading = false;
        },
        fetchError: (state, action) => {
            state.loading = false;
            state.error = action.payload || "An error occurred";
        },
    },
    sagas: (A) => ({
        *[A.search]({ payload }) {
            try {
                console.log(payload);
                const { data } = yield call(refundService.search, payload);
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.addRefund]({ payload }) {
            try {
                const { data } = yield call(refundService.save, payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },

        *[A.updateRefund]({ payload }) {
            try {
                const { data } = yield call(refundService.update, payload);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);

            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.deleteRefund]({ payload }) {
            try {
                const { data } = yield call(refundService.delete, payload.id);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        
        
    }),
});

export default refundSlice;
export const refundActions = refundSlice.actions;